var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinerInProgerss),expression:"spinerInProgerss"}],staticClass:"spinner-box"},[_c('div',{staticClass:"spinner"})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }